import { render, staticRenderFns } from "./CadastrarUnidade.vue?vue&type=template&id=5209c3c2&scoped=true"
import script from "./CadastrarUnidade.vue?vue&type=script&lang=js"
export * from "./CadastrarUnidade.vue?vue&type=script&lang=js"
import style0 from "./CadastrarUnidade.vue?vue&type=style&index=0&id=5209c3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5209c3c2",
  null
  
)

export default component.exports